// extracted by mini-css-extract-plugin
export default {"headerWrap":"index_headerWrap_mrgkf","subNav":"index_subNav_-mY8P","main":"index_main_3PkeU","footerWrap":"index_footerWrap_IZu94"};